import { cn } from "@/components/podkit/lib/cn";
import type { ComponentProps, FC } from "react";

/**
 * A component that renders content that is screen-reader accessible by default,
 * but only visually visible when the parent container with the "group" class
 * is hovered or has focus-within.
 *
 * @requires Parent element must have the "group" class for hover/focus-within effects to work
 *
 * @example
 * ```tsx
 * <div className="group">
 *   <button>Main content</button>
 *   <VisibleOnActive>Click to activate</VisibleOnActive>
 * </div>
 * ```
 */
export const VisibleOnActive: FC<ComponentProps<"span">> = ({ className, children, ...props }) => {
    return (
        <span className={cn("sr-only group-focus-within:not-sr-only group-hover:not-sr-only", className)} {...props}>
            {children}
        </span>
    );
};
